import nataliiaRomanyshyn from "@/assets/images/speakers/nataliia-romanyshyn.jpg";
import antonLiagusha from "@/assets/images/speakers/anton-liagusha.jpg";
import arndtFreytagVonLoringhoven from "@/assets/images/speakers/arndt-freytag-von-loringhoven.jpg";
import valVoshchevska from "@/assets/images/speakers/val-voshchevska.jpg";
import botakozKassymbekova from "@/assets/images/speakers/botakoz-kassymbekova.jpg";
import mattiaNelles from "@/assets/images/speakers/mattia-nelles.jpg";
import philipObaji from "@/assets/images/speakers/philip-obaji.jpg";
import dmytroIarovyi from "@/assets/images/speakers/dmytro-iarovyi.jpg";
import drYehorBrailian from "@/assets/images/speakers/dr-yehor-brailian.jpg";
import annaRomandash from "@/assets/images/speakers/anna-romandash.jpg";
import tatianaCojocari from "@/assets/images/speakers/tatiana-cojocari.jpg";
import drVeronikaSolopova from "@/assets/images/speakers/dr-veronika-solopova.jpg";
import nouranAlghamian from "@/assets/images/speakers/nouran-alghamian.jpg";
import oleksiiKovzhun from "@/assets/images/speakers/oleksii-kovzhun.jpg";
import peterPomerantsev from "@/assets/images/speakers/peter-pomerantsev.jpg";
import anaSarbu from "@/assets/images/speakers/ana-sarbu.jpg";
import mariaZoryk from "@/assets/images/speakers/mariia-zoryk.jpg";
import alexejHock from "@/assets/images/speakers/alexej-hock.jpg";
import dietmarPichler from "@/assets/images/speakers/dietmar-pichler.jpg";
import robertPutzbach from "@/assets/images/speakers/robert-putzbach.jpg";
import katerynaRietzRakul from "@/assets/images/speakers/kateryna-rietz-rakul.jpg";
import irynaShulikina from "@/assets/images/speakers/iryna-shulikina.jpg";
import dmytroKuleba from "@/assets/images/speakers/dmytro-kuleba.jpg";
import katerynaTarabukina from "@/assets/images/speakers/kateryna-tarabukina.jpg";
import olesiaSaienko from "@/assets/images/speakers/olesia-saienko.jpg";
import annaPotyomkina from "@/assets/images/speakers/anna-potyomkina.jpg";
import catenation from "@/assets/images/speakers/catenation.jpg";
import fantasticLittleSplash from "@/assets/images/speakers/fantastic-little-splash.jpg";
import valeriaBarbas from "@/assets/images/speakers/valeria-barbas.jpg";
import kseniaMalykh from "@/assets/images/speakers/ksenia-malykh.jpg";
import olenaApchel from "@/assets/images/speakers/olena-apchel.jpg";

const SPEAKERS = [
  {
    id: 32,
    url: "speaker/olena-apchel",
    name: "Dr. Olena Apchel",
    title: "Doctor of Arts (PhD), performer, servicewoman",
    company: "",
    image: olenaApchel,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Dr Olena Apchel is a Ukrainian theater director and researcher known for her work at the intersection of art, history, and social issues. She has served as the chief director of the Lesya Ukrainka Theater in Lviv and as a director at the Kyiv “Golden Gate” Theater. She also co-created the main exhibition at the Museum of Totalitarian Regimes “Territory of Terror.”  \n \nIn 2020, Olena joined Warsaw’s Nowy Teatr to lead its social programs department, and in 2022, she moved to Berlin, where she worked as co-director of Theatertreffen, the largest theater festival in the German-speaking world, Olena returned to Ukraine in 2024, joining the Armed Forces to support her homeland.",
  },

  {
    id: 23,
    url: "speaker/dmytroKuleba",
    name: "Dmytro Kuleba",
    title:
      "Former Minister for Foreign Affairs of Ukraine, Senior Fellow at Harvard’s Belfer Center",
    twitter: "https://x.com/dmytrokuleba",
    instagram: "https://www.instagram.com/dmytro_kuleba",
    image: dmytroKuleba,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Dmytro Kuleba, Ukraine’s Minister for Foreign Affairs (2020–2024) and non-resident Senior Fellow at Harvard’s Belfer Center, led Ukraine’s diplomacy during the Russian invasion, securing arms, alliances, and advancing EU and NATO bids. Known for pioneering wartime communications, he introduced the world’s first AI-driven spokesperson for a foreign ministry. Author of The War for Reality and War and New Horizons, he explores information warfare and Ukraine’s global role. A Ph.D. in International Law, Kuleba has held key roles in diplomacy, including Ambassador to the Council of Europe and Deputy Prime Minister for European Integration.",
  },
  {
    id: 15,
    url: "speaker/peter-pomerantsev",
    name: "Peter Pomerantsev",
    title: "Journalist and Author",
    company: "John Hopkins University",
    image: peterPomerantsev,
    twitter: "https://x.com/peterpomeranzev",
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Peter Pomerantsev is a senior fellow at Johns Hopkins University and co-director of the Arena Initiative. Born in Kyiv, Ukraine, and raised in the U.K., he is a prominent author and expert on propaganda and information warfare. His works critically examine Russian and other authoritarian disinformation strategies. His latest book, How to Win an Information War: The Propagandist Who Outwitted Hitler (2024), adds to his acclaimed publications that explore the evolving nature of propaganda in the modern world.",
  },
  {
    id: 22,
    url: "moderator/iryna-shulikina",
    name: "Iryna Shulikina",
    title: "Executive Director",
    company: "Vitsche e.V.",
    linkedin: "https://www.linkedin.com/in/iryna-s-9ab29359/",
    instagram: "https://www.instagram.com/iryna_shulikina/",
    image: irynaShulikina,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Iryna Shulikina is a cultural manager and activist with a commitment to connecting culture and social impact. As CEO of Vitsche e.V., she leads efforts to strengthen Ukrainian subjectivity, counter disinformation, and promote democracy. With experience as a consultant and communication manager, Iryna has supported creative and cultural initiatives across Europe. Her work bridges cultural and political advocacy, fostering international solidarity and support for Ukraine.",
  },
  {
    id: 14,
    url: "speaker/oleksii-kovzhun",
    name: "Oleksii Kovzhun",
    title: "Media Strategist and Communications Expert",
    company: "Grunt media",
    image: oleksiiKovzhun,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Oleksii Kovzhun is a media strategist and communications expert with a diverse background in public service, political campaigns, and media production. He is a radio host on Radio NV and a presenter at Grunt Media. Previously, he advised on information warfare at Kyiv City Council and held roles with UNICEF Ukraine, Saatchi & Saatchi, and political leaders such as Yulia Tymoshenko. He co-founded the activist coalition “Who is Behind the Murder of Katya Handzyuk?” and lectures on media and communications at Ukrainian universities.",
  },
  {
    id: 1,
    url: "speaker/nataliia-romanyshyn",
    name: "Nataliia Romanyshyn",
    title: "NLP Researcher",
    company: "Texty.org.ua",
    linkedin: "https://www.linkedin.com/in/nataliia-romanyshyn-b45994161/",
    image: nataliiaRomanyshyn,
    // imageBg: nataliiaRomanyshynBg,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Nataliia Romanyshyn is an NLP specialist at Texty.org.ua, focused on applying natural language processing to support data-driven journalism. With expertise in studying propaganda and disinformation, she uses techniques like topic modeling and named entity recognition to transform complex text data into insights, advancing clarity and accountability in journalism.",
  },
  {
    id: 19,
    url: "speaker/dietmar-pichler",
    name: "Dietmar Pichler",
    title: "Director/Founder",
    company: "Disinfo Resilience Network",
    instagram: "https://www.instagram.com/p_dietmar/",
    twitter: "https://x.com/dietmarpichler1",
    linkedin: "https://www.linkedin.com/in/dietmar-pichler-26a75649/",
    image: dietmarPichler,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Dietmar Pichler is the Director and Founder of the Disinfo Resilience Network. He is an analyst specializing in disinformation and foreign interference, as well as an advocate for stronger democratic resilience and effective responses to the threat posed by active measures from authoritarian regimes such as Russia and its allies. Pichler also serves as Vice President of the NGO “Vienna Goes Europe”.",
  },

  {
    id: 5,
    url: "speaker/prof-botakoz-kassymbekova",
    name: "Prof. Botakoz Kassymbekova",
    title: "Chair of Eastern European History",
    company: "University of Zurich",
    image: botakozKassymbekova,
    // imageBg: "@/assets/images/speakers/botakoz-kassymbekova-bg.jpg",
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Professor Botakoz Kassymbekova is chair of Eastern European history at the University of Zurich, specializing in Stalinist and post-Stalinist eras and Russian imperial history. She holds a Ph.D. from Humboldt University in Berlin and has held postdoctoral positions in Berlin, Liverpool, and Basel, with visiting roles at Columbia University. Her book Despite Cultures: Early Soviet Rule in Tajikistan explores Soviet imperial strategies in Central Asia and dictatorship dynamics. Her current research investigates post-Stalinist Soviet imperialism through aging populations, adding a unique perspective to Soviet studies.",
  },

  {
    id: 3,
    url: "speaker/arndt-freytag-von-loringhoven",
    name: "Arndt Freytag von Loringhoven",
    title: "Former German Ambassador",
    image: arndtFreytagVonLoringhoven,
    // imageBg: "@/assets/images/speakers/arndt-freytag-von-loringhoven-bg.jpg",
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Arndt Freytag von Loringhoven is a retired German diplomat with a career spanning posts at German Embassies in Paris and Moscow and various roles in the Foreign Ministry, including European Affairs Director. He was NATO’s first Assistant Secretary General for Intelligence and Security and served as German Ambassador to the Czech Republic and Poland until 2022. In 2024, he published Putins Angriff auf Deutschland: Disinformation, Propaganda, Cyberattacken, analysing modern Russian disinformation and cyber strategies.",
  },
  {
    id: 2,
    url: "speaker/dr-anton-liagusha",
    name: "Dr. Anton Liagusha",
    title: "Historian",
    company: "Kyiv School of Economics",
    instagram: "https://www.instagram.com/a.liagusha/",
    image: antonLiagusha,
    // imageBg: "@/assets/images/speakers/anton-liagusha-bg.jpg",
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Anton Liagusha is a Ukrainian historian and academic director of the “Memory Studies and Public History” Master’s program at Kyiv School of Economics. His work centers on historical memory and the Russo-Ukrainian conflict, organizing programs and projects to raise public awareness of memory’s role in society. Liagusha collaborates widely with cultural and educational institutions and has taught in Europe and the U.S. His research and educational efforts significantly influence memory studies and public historical awareness in Ukraine.",
  },

  {
    id: 7,
    url: "speaker/nouran-alghamian",
    name: "Nouran Alghamian",
    title: "Human Rights Advocate",
    // company: "",
    image: nouranAlghamian,
    // imageBg: "@/assets/images/speakers/nouran-alghamian-bg.jpg",
    instagram: "https://www.instagram.com/nuraneh/",
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Nouran Alghamian is a Syrian human rights advocate and former political prisoner, currently living in political asylum in Switzerland. Arrested during the 2011 protests against the Syrian government, she endured imprisonment in a notorious interrogation center. Her experiences have been instrumental in the landmark trial of former Syrian intelligence officers Anwar Raslan and Eyad al-Gharib in Germany for crimes against humanity. The trial marked the first prosecution of high-ranking Syrian officials for state-sponsored torture during the civil war. Alghamian’s testimony highlights her commitment to justice and accountability for victims of war crimes and human rights violations.",
  },

  {
    id: 4,
    url: "speaker/valeriia-voshchevska",
    name: "Valeriia Voshchevska",
    title: "Activist and Digital Strategist",
    company: "Ukraine Solidarity Project",
    instagram: "https://www.instagram.com/vally_v/",
    image: valVoshchevska,
    // imageBg: "@/assets/images/speakers/val-voshchevska-bg.jpg",
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Val Voshchevska is a Ukrainian activist and digital strategist with expertise in media and strategic communications. Formerly Global Head of Digital Engagement at Amnesty International, she shifted focus entirely to supporting Ukraine after Russia’s 2022 invasion. Voshchevska educates global audiences on Ukrainian issues and has led impactful campaigns, successfully pressuring corporations like Pernod Ricard to exit Russia. Her reflections on the war appear in TIME, Al Jazeera, and outlets like NYT, Guardian, and BBC, positioning her as a prominent voice on Ukraine’s challenges and resilience.",
  },
  {
    id: 18,
    url: "speaker/alexej-hock",
    name: "Alexej Hock",
    title: "Journalist",
    company: "CORRECTIV",
    image: alexejHock,
    bluesky: "https://bsky.app/profile/alexejhock.bsky.social",
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Alexej Hock worked in the investigative department of Die Welt after training at the Axel Springer Academy. He is at CORRECTIV since February 2024. He is focusing on investigating Russian influence operations.",
  },
  {
    id: 8,
    url: "speaker/philip-obaji",
    name: "Philip Obaji",
    title: "Independent Journalist",
    // company: "",
    image: philipObaji,
    twitter: "https://x.com/philipobaji",
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Philip Obaji Jr. is an award-winning journalist who has documented human rights abuses by Russian paramilitaries in West and Central Africa. His investigations into Wagner Group atrocities and refugee trafficking have highlighted the hidden consequences of war. Despite threats and personal danger, Obaji continues to report on exploitation, earning him international recognition, including the 2022 Jaime Brunet International Human Rights Prize and 2023 One World Media International Journalist of the Year award.",
  },
  {
    id: 17,
    url: "moderator/mariia-zoryk",
    name: "Mariia Zoryk",
    title: "Communications Manager",
    company: "Ukrainian Institute",
    image: mariaZoryk,
    instagram: "https://www.instagram.com/m_zoryk/",
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Mariia Zoryk completed her Master’s degree as a DAAD fellow in Literature and Media Studies at Otto Friedrich University in Bamberg. As a PR specialist, she worked for the festivals such as “Bamberg Short Film Festival”, Ukrainian Film Festival Berlin as well as Tanzwerkstatt Europa and Tanzplattform Deutschland in Munich. In 2022 she started the aid initiative “Bamberg helps Ukraine” and was awarded the Special Culture Prize of the City of Bamberg for Ukrainian artists.",
  },

  {
    id: 6,
    url: "speaker/mattia-nelles",
    name: "Mattia Nelles",
    title: "CEO and co-founder",
    company: "German-Ukrainian Bureau",
    twitter: "https://x.com/mattia_n",
    linkedin: "https://www.linkedin.com/in/mattianelles/",
    image: mattiaNelles,
    // imageBg: "@/assets/images/speakers/mattia-nelles-bg.jpg",
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Mattia Nelles is the CEO and co-founder of the German-Ukrainian Bureau, specializing in research and strategic advisory to strengthen German-Ukrainian relations in civil society, business, and government. Previously, he was a foreign policy advisor to a Bundestag member and worked in Ukraine for GIZ, focusing on community development in Eastern Ukraine. Nelles has extensive experience in Eastern Europe, especially Ukraine, where he lived and worked for several years. Until 2020, he was Program Director for Ukraine at Berlin’s Center for Liberal Modernity, managing projects with Ukrainian parliamentarians.",
  },

  {
    id: 9,
    url: "moderator/dmytro-iarovyi",
    name: "Dr. Dmytro Iarovyi",
    title:
      "Associate Professor at Kyiv School of Economics; Lecturer at Vytautas Magnus University (Lithuania)",
    // company:
    // "Kyiv School of Economics (Ukraine); Vytautas Magnus University (Lithuania)",
    image: dmytroIarovyi,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Dr. Dmytro Iarovyi is an academic specializing in public policy, political communication, and information disorders. An Associate Professor at Kyiv School of Economics, he also serves as Academic Director of the Ph.D. Program in Public Policy. His interdisciplinary research focuses on resilience to information disorders and discourse analysis. Iarovyi also has practical experience as a government relations consultant and has held positions in Ukraine's Ministry of Finance and academia in Lithuania.",
  },

  {
    id: 31,
    url: "speaker/ksenia-malykh",
    name: "Ksenia Malykh",
    title: "Art historian, Curator and Researcher",
    image: kseniaMalykh,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Art historian, curator, researcher, Head of the Research Platform of PinchukArtCentre, Kyiv, Ukraine, and artistic director of Promprylad Artcentre, Ivano-Frankivsk, Ukraine. Co-founder of the OK Projects NGO and Closer Art Center, Kyiv, Ukraine. General manager of the Ukrainian national pavilion on 58th Biennale in Venice, co-curator of From Ukraine: Dare to Dream, a Collateral Event of the 60th International Art Exhibition — La Biennale di Venezia. She produces publications on the history of Ukrainian contemporary art. In her research and curatorial activities, she focuses on artistic practices related to memory, history, and the combination of the political and the poetic. She also teaches contemporary art to teenagers at a democratic school in Maibutni. Based in Kyiv, Ukraine.",
  },

  {
    id: 10,
    url: "speaker/dr-yehor-brailian",
    name: "Dr. Yehor Brailian",
    title: "Analyst",
    company: "Detector media",
    image: drYehorBrailian,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Dr. Yehor Brailian is a Ukrainian historian, journalist, and analyst at Detector Media. An alumnus of Kyiv National Taras Shevchenko University, with further studies at Constance University and participation in global history workshops at Pembroke College, Oxford, he holds a Ph.D. in History. Yehor focuses on Russian propaganda in NATO countries, information operations in occupied Ukrainian territories, and media collaboration with Russia. In addition to his journalism work, he is an Associate Professor at the State University «Kyiv Aviation Institute», teaching courses on think tanks, media, and public relations in international relations.",
  },
  {
    id: 30,
    url: "moderator/kateryna-tarabukina",
    name: "Kateryna Tarabukina",
    title: "Cultural project manager & curator",
    company: "Vitsche e.V.",
    instagram: "https://www.instagram.com/berlinbykate",
    image: katerynaTarabukina,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Kateryna Tarabukina is a Berlin-based curator from Kyiv. She specializes in public programs and international collaborative projects with interdisciplinary approaches. A member of Vitsche e.V. in Berlin, her recent endeavors include curating the 'Checkpoint Peace' platform and the 'Artist as Prophet' public program. She is the founder and curator of 'The Nexus of Decision,' an international academy residency for scholars from Germany, Poland, and Ukraine and an Artistic Fellowship in the “Truth to Justice” platform for fighting propaganda and disinformation. Her background is MA in International Economy and a second in Cultural Studies. Her research interests encompass memory studies, history, political science, international relations, and contemporary artistic practices. Recently, she has concentrated on fostering interdisciplinary dialogue aimed at ensuring peaceful and secured coexistence, as well as equal rights for diverse communities. She views curiosity, re-learning, re-discovery, and justice as critical tools in combating false narratives, imperialism, and colonialism in the European mindset.",
  },

  {
    id: 11,
    url: "speaker/anna-romandash",
    name: "Anna Romandash",
    title: "Journalist",
    // company: "",
    image: annaRomandash,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Anna Romandash is an award-winning journalist from Ukraine and author of Women of Ukraine: Reportages from the War and Beyond (2023). Recognized as a Media Freedom Ambassador of Ukraine, she has won accolades from the European Institute of the Mediterranean, Internews, the Council of Europe, and the Samovydets Literary Reportage Contest. Her work focuses on the intersection of media, technology, and human rights, with a passion for fostering inclusive technology and advancing digital democracy in developing societies.",
  },
  {
    id: 21,
    url: "moderator/kateryna-rietz-rakul",
    name: "Kateryna Rietz-Rakul",
    title: "Head of the Representative Office",
    company: "Ukrainian Institute in Germany",
    linkedin: "https://www.linkedin.com/in/kateryna-rietz-rakul/",
    image: katerynaRietzRakul,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Kateryna Rietz-Rakul studied English and American Studies in Lviv and Berlin and graduated with a PhD in contemporary literature. She is an interpreter, translator, author and cultural manager. Kateryna lives and works in Berlin. Previously, she was co-founder of APES, a curatorial collective in Berlin. Kateryna Rietz-Rakul has contributed for numerous international art magazines and published several books, including a city guide to the Berlin cultural scene, Berlin Contemporary Art. As a cultural manager, Kateryna Rietz-Rakul is co-founder of KUL’TURA e.V., which promotes international cooperation between creatives from Ukraine and other countries.",
  },
  {
    id: 24,
    url: "speaker/olesia-saienko",
    name: "Olesia Saienko",
    title: "Artist",
    // company: "",
    image: olesiaSaienko,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Olesia Saienko is a photographer and visual storyteller from Ukraine. She holds a Master's degree in Psychology and started working as a photojournalist and freelancer in 2017. Olesia mainly uses photography as a tool for her expression; however, in recent projects, she has expanded her practice to include video, installations, and art-book formats. Her work centers around fiction, death documentary, and post-truth, which serves as a natural extension of her background in journalism and psychology. She is both an archivist and a trickster. Olesia is a member of the Ukrainian Women Photographers Organization and is represented by Asortymentna Kimnata. She lives and works in Ivano-Frankivsk and Lviv, Ukraine.",
  },
  {
    id: 25,
    url: "speaker/anna-potyomkina",
    name: "Anna Potyomkina",
    title: "Artist",
    // company: "",
    image: annaPotyomkina,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Anna Potyomkina іs an artist and a curator. Born in Mykolaiv, based in Ivano-Frankivsk, Ukraine. Studied art history and theory at the Lviv Academy of Arts and the Poznań University of Arts. As the artist, she works with video, text, bodily and performative practices. Anna is interested in issues of collective and personal memory, the relationship between the body and the landscape, rituality and mundane, and the phenomenon of the periphery with its socio-cultural manifestations. Anna is part of the Memory Lab collective and a cofounder of Asortymentna Kimnata.",
  },
  {
    id: 12,
    url: "speaker/dr-tatiana-cojocari",
    name: "Dr. Tatiana Cojocari",
    title: "Researcher & Disinformation Expert",
    company: "WatchDog.MD Community",
    image: tatianaCojocari,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Tatiana Cojocari is a Disinformation Expert at WatchDog.MD Community, a think tank in Chișinău, Moldova. She specializes in the foreign policy of the Russian Federation in Eastern Europe, conflict resolution in the Black Sea Region, and political sociology. A Fulbright alumna with a PhD on Russian religious diplomacy, Tatiana has consulted for the World Bank, GIZ, and the European Commission. She was also a Postdoctoral Researcher at the Romanian Centre for Russian Studies, focusing on disinformation and Transnistrian issues.",
  },
  {
    id: 13,
    url: "speaker/dr-veronika-solopova",
    name: "Dr. Veronika Solopova",
    title: "Post-doctoral Research Assistant",
    company: "Technische Universität Berlin",
    image: drVeronikaSolopova,
    showOnHomepage: true,
    showOnSpeakersPage: true,
  },
  {
    id: 27,
    url: "speaker/catenation",
    name: "Catenation",
    title: "Artist group",
    // company: "",
    image: catenation,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Catenation displays a very unique, organic approach to industrial, noise, and ambient aesthetics. Catenation uses instruments such as recorders (from sopranino to sub double bass), modular systems, analog and digital synthesizers, electric bass guitar, found object percussion as well as broken retro equipment. Catenation has performed at e.g. Krema Festival CH, Unerhörte Musik DE, Rock Sound EG, SoundsLikeTHIS UK, Dampfzentrale Bern CH, Interfilm Festival Berlin DE, Goethe Institute Cairo EG and Alexandria EG, IntegratedConf BE, Marry Klein Kulturdonnerstag DE, Setfest IR and Klangwerkstatt Festival DE, played as support for Plaid, appeared on compilations such as Listen To Berlin and received scholarships from the Musikfonds, Neustart Kultur and the Goethe Institute. \n \nSylvia Hinz is a performer/improviser. Praised for her equally fierce and bold dramatic performance style, Sylvia Hinz is one of the leading recorder players worldwide, specializing in contemporary music and improvisation. In addition to intensive sound research for the instrument recorder, Hinz breaks new ground with the combination of sound, electronics & video art and works with numerous international composers such as Mathias Spahlinger (DE), Violeta Dinescu (RO), Jeanne Artemis (DE), Zeynep Gedizlioglu (TR), Cat Hope (AU), Michele Abondano (CO), Sarah Angliss (UK). \n \nJeanne Artemis is a composer/musician. Her commitment to pushing the boundaries of her art in various genres has not only garnered acclaim but has also served as a source of inspiration for many others to follow. She has received scholarships from the Goethe Institute, the Berlin Senate Department for Culture and Europe, Musikfonds e.V., Neustart Kultur, and Deutscher Musikrat among others. A portrait was published in the 'Neue Zeitschrift für Musik' (issue #2_2021). Her works are performed by renowned solists and ensembles around the world. Together, Sylvia Hinz and Jeanne Artemis extravagate the worlds of Dissonant Art Music, Metal, and Industrial / Noise.",
  },
  {
    id: 16,
    url: "speaker/ana-sarbu",
    name: "Ana Sârbu",
    title: "Journalist",
    // company: null,
    image: anaSarbu,
    instagram: "https://www.instagram.com/as.journalist/",
    linkedin: "https://www.linkedin.com/in/ana-s%C3%A2rbu-412b3033/",
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Ana Sârbu is a seasoned journalist and communications specialist from Moldova. She has worked across various media platforms, including print, television, and digital, holding roles as a reporter, producer, and anchor. Ana was the host and producer of DezinFAKEtarea (Eng. “disinFAKEtion”), a TV program dedicated to exposing fake news and political manipulation in Moldova. She also hosts the podcast cuMINTE and teaches journalism at university and elementary levels, nurturing future media professionals. Through her efforts, she promotes responsible journalism and counters misinformation across platforms.",
  },
  {
    id: 20,
    url: "speaker/robert-putzbach",
    name: "Robert Putzbach",
    title: "Journalist",
    company: "Frankfurter Allgemeine Zeitung",
    image: robertPutzbach,
    twitter: "https://x.com/RobertPutzbach",
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Robert Putzbach is a staff writer in the politics department of the Frankfurter Allgemeine Zeitung (F.A.Z.). His main focus is on Eastern Europe; Since the beginning of the full-scale invasion he has been reporting primarily on and from Ukraine. He regularly travels to the country and writes reports from the ground. He was awarded the ‘n-ost Research Prize for Eastern Europe 2019’. In his master's thesis, he examined Russian strategies of influence in the context of the coronavirus pandemic.",
  },
  {
    id: 28,
    url: "speaker/fantastic-little-splash",
    name: "fantastic little splash",
    title: "Artist group",
    // company: "",
    image: fantasticLittleSplash,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "fantastic little splash is a collective comprised of journalist/artist Lera Malchenko and artist/director Oleksandr Hants. fantastic little splash combines art practice and media studies to research collective imagination and emotions appropriation in technosocial systems. The group works with videos, texts, and interactive game-based tools. Established in 2016 in Ukraine, their projects have been exhibited at events including transmediale, post.MoMA, Plokta TV, Ars Electronica, Liste Art Fair Basel, Construction festival VI x CYNETART, KISFF, and Docudays, among others. fantastic little splash – participants of the Transmediale x Pro Helvetia Residency 2022, and the Cité internationale des arts residency 2023.",
  },
  {
    id: 29,
    url: "speaker/valeria-barbas",
    name: "Valeria Barbas",
    title: "Artist",
    // company: "",
    image: valeriaBarbas,
    showOnHomepage: true,
    showOnSpeakersPage: true,
    bio: "Valeria Barbas is a Moldovan mixed media artist, curator, and senior researcher at the Institute of Cultural Heritage in Chișinău. Holding degrees in music composition, singing, and painting, she explores performance, video art, sound, and experimental film. Her projects have been showcased internationally, including at the Venice Biennale. A Ph.D. holder in art and culturology, Valeriia is also a prolific writer, with over 70 publications examining Moldova’s contemporary art and “new music.” Her recent work reflects on societal fragility and transformation, as seen in projects like My Home/ACASĂ and Propaganda Room.",
  },
];

export default SPEAKERS;
